<template>
  <base-widget :loading="loading">
    <template slot="title">{{
      $t("widgets.inhibitorsPositivePercentage.title")
    }}</template>

    <template slot="text">
      <h1 class="text-center">
        <span v-counter="positiveInhibitorCount">0</span>%
      </h1>
    </template>
  </base-widget>
</template>

<script>
import gql from "graphql-tag";
import BaseWidget from "./BaseWidget.vue";
export default {
  components: { baseWidget: BaseWidget },
  data() {
    return {
      inhibitorsStats: 0,
      loading: true,
    };
  },
  computed: {
    positiveInhibitorCount() {
      if (this.$store.state.dashboardData == null) return 0;
      return (
        Math.round(
          this.$store.state.dashboardData["percentageOfPositiveInhibitorTest"] *
            100
        ) / 100
      );
    },
    filters() {
      return this.$store.getters.filters;
    },
    filtersRegion() {
      return this.filters.region;
    },
    filtersAge() {
      return this.filters.ageGroup;
    },
    filtersGni() {
      return this.filters.gni;
    },
    filtersRegistrationYears() {
      return this.filters.dateOfRegistration;
    },
  },
  watch: {
    positiveInhibitorCount(val) {
      if (val != null) this.loading = false;
    },
  },
  // watch: {
  //   htcCount: function () {
  //     this.counterHelper(this.htcCount, this.$refs["counter"]);
  //   },
  // },
  // apollo: {
  //   inhibitorsStats: {
  //     query: gql`
  //       query InhibitorsStats(
  //         $regions: [String]
  //         $minAge: Int
  //         $maxAge: Int
  //         $gni: [String]
  //         $hemoTypes: [String]
  //         $minRegistrationYear: Int
  //         $maxRegistrationYear: Int
  //       ) {
  //         positiveInhibitorPercentage(
  //           regions: $regions
  //           ageGroup: { min: $minAge, max: $maxAge }
  //           gni: $gni
  //           hemophiliaTypes: $hemoTypes
  //           registrationYear: {
  //             min: $minRegistrationYear
  //             max: $maxRegistrationYear
  //           }
  //         )
  //       }
  //     `,
  //     variables() {
  //       var filters = this.filters;
  //       var v = {
  //         regions: filters.region,
  //         gni: filters.gni,
  //       };
  //       return v;
  //     },
  //     update: (data) => data.positiveInhibitorPercentage,
  //     watchLoading({ loading, key }) {
  //       this.loading = loading;
  //     },
  //   },
  // },
};
</script>